import { Navigate, Outlet } from 'react-router-dom'
import { useAuthStore } from '../store/authStore'

// Administrace je dostupná POUZE pro vyhrazený admin účet
// (musí mít zároveň role=admin a správný email). Backend to vynucuje navíc.
export default function AdminRoute() {
  const { user } = useAuthStore()
  const adminEmail = (import.meta.env.VITE_ADMIN_EMAIL as string) || 'info@seo-solution.cz'
  const isAdmin = user?.role === 'admin' && user?.email?.toLowerCase() === adminEmail.toLowerCase()

  if (!isAdmin) {
    return <Navigate to="/dashboard" replace />
  }

  return <Outlet />
}
